/** The six jobs: the only top-level navigation (Events joined on 26 Oct 2026, David's decision, #705). Page titles come from these labels. */
import type { IconName } from "../kit";
import type { QueueKey } from "../data/queues";

export interface Job {
  to: string;
  label: string;
  icon: IconName;
  /** The tenant capability the job needs; without one, everyone signed in sees it. */
  capability?: string;
}

export const JOBS: readonly Job[] = [
  { to: "/", label: "Today", icon: "nav-dashboard" },
  { to: "/people", label: "People", icon: "user-group" },
  { to: "/events", label: "Events", icon: "calendar" },
  // Campaigns and licence reminders (#716): staff, and the manager for the reminders; not the reviewer.
  { to: "/email", label: "Email", icon: "comment", capability: "email" },
  { to: "/money", label: "Money", icon: "analytics", capability: "finance" },
  { to: "/settings", label: "Settings", icon: "nav-settings" },
];

/** The job a v2 pathname belongs to, or undefined (Labs, not found). */
export function jobFor(pathname: string): Job | undefined {
  return JOBS.find((job) => (job.to === "/" ? pathname === "/" : pathname.startsWith(job.to)));
}

/** True when a role's capability list (`["*"]` for full access) lets it see the job. */
export function canSee(job: Job, capabilities: readonly string[] | undefined): boolean {
  return !job.capability || !!capabilities?.some((c) => c === "*" || c === job.capability);
}

/** The People tree in the sidebar: the main views, by registry id (screens/people/views.ts holds the titles). */
export const PEOPLE_TREE = ["all", "active", "lapsed", "suspended", "at-risk", "arrivals", "licences"] as const;

export const QUEUE_ICON: Record<QueueKey, IconName> = {
  payment: "nav-ticket",
  lapsed65: "clock",
  lapsed120: "timer",
  licences: "file",
  held: "user-card",
};
